import PropTypes from 'prop-types';
import React from 'react';
import articleApi from '../../../api/article.jsx';
import {intlShape, injectIntl} from 'react-intl';

class ArticleFav extends React.Component {
  static propTypes = {
    intl: intlShape.isRequired,
    article: PropTypes.shape({
      fav: PropTypes.bool,
      id: PropTypes.any,
    }),
  };

  state = {faved: false};

  componentWillMount() {
    if (this.props.article) {
      this.setState({faved: this.props.article.fav});
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.article) {
      this.setState({faved: nextProps.article.fav});
    }
  }

  favIt = () => {
    this.setState({faved: true});
    articleApi.favoriteShelfArticle(this.props.article.id.toString());
  };

  unFavIt = () => {
    this.setState({faved: false});
    articleApi.favoriteShelfArticle(this.props.article.id.toString());
  };

  render() {
    let fav = this.state.faved ? 'icon bl bl-star-filled favourited' : 'icon bl bl-star not-favourited';
    let func = this.state.faved ? this.unFavIt : this.favIt;

    return (
      <h3 className='pull-left article-fav'>
        <i className={fav} onClick={func} data-event-category='User' data-event-action='article-fav'
            title={this.props.intl.formatMessage({id: 'article.refer.article.alot'})} />
      </h3>
    );
  }
}

export default injectIntl(ArticleFav);
